var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{staticClass:"text-center"},[_c('h2',[_vm._v("Login")]),_c('b-button',{on:{"click":_vm.signin_google}},[_c('i',{staticClass:"fab fa-google",attrs:{"variant":"primary"}}),_vm._v(" Login with Google")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }